/**
 * Created by DejanK on 5/9/2016
 *
 * Prints a date from string
 *
 * usage:
 * rbDate: "empty label"
 */

import isString from 'lodash/isString';

export default rbDateFilter;

function rbDateFilter()
{
  return function printRbDate(dateString, emptyLabel){
    if(!dateString || !isString(dateString) || !dateString.length) {
      return emptyLabel || 'none';
    }
    const ymd = dateString.slice(0, 10).split('-');
    return `${ymd[1]  }/${  ymd[2]  }/${  ymd[0]}`;
  };
}
